import { Directive, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../services/dialog.service';

@Directive({
  selector: '[copyPasteBlocker]'
})
export class CopyPasteDirective {
  constructor(private translate : TranslateService) { }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
    DialogService.Warning(this.translate.instant("DIALOGS.COPY_PASTE_DISABLED"));
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
    DialogService.Warning(this.translate.instant("DIALOGS.COPY_PASTE_DISABLED"));
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
    DialogService.Warning(this.translate.instant("DIALOGS.COPY_PASTE_DISABLED"));
  }
}
